import loginStore from "./modules/loginStore";
import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";

export default createStore({
  /*
    역할: 상태 정의 (data)
    state는 mutation을 통해서 만 변경이 가능
  */
  state: {
    selectedMenu: "",
    theme: "dark", // 'dark' or 'light'
    activeModal: null, // 전역 모달 키 (GlobalModalHost 가 렌더). null 이면 닫힘
  },

  /*
    역할: 상태 호출 (computed)
    state에 대해 연산하고 결과를 다시 view에 바인딩
  */
  getters: {
    selectedMenu: (state) => state.selectedMenu,
    theme: (state) => state.theme,
    isDarkMode: (state) => state.theme === "dark",
    activeModal: (state) => state.activeModal,
  },

  /*
    역할: state를 변경하는 유일한 방법
    호출: commite
  */
  mutations: {
    setSelectedMenu(state, menu) {
      state.selectedMenu = menu;
    },
    setActiveModal(state, name) {
      state.activeModal = name;
    },
    setTheme(state, theme) {
      state.theme = theme;
      // HTML root element에 dark 클래스 토글
      if (theme === "dark") {
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("dark");
      }
    },
  },

  /*
    역할: 상태 변경을 위한 동작
          비동기 작업이 가능 -> api호출 후 결과에 대한 return 또는 mutaions을 호출하기 위한 commit
    호출: dispatch
  */
  actions: {
    updateSelectedMenu({ commit }, menu) {
      commit("setSelectedMenu", menu);
    },
    openModal({ commit }, name) {
      commit("setActiveModal", name);
    },
    closeModal({ commit }) {
      commit("setActiveModal", null);
    },
    toggleTheme({ commit, state }) {
      const newTheme = state.theme === "dark" ? "light" : "dark";
      commit("setTheme", newTheme);
    },
    initTheme({ commit, state }) {
      // 초기 테마 적용
      commit("setTheme", state.theme);
    },
  },

  /*
    역할: 모듈별(기능 또는 페이지)로 store을 분리하고 호출하여 관리
  */
  modules: {
    loginStore,
  },
  plugins: [
    createPersistedState({
      paths: ["loginStore", "theme"],
    }),
  ],
});
